<template>
  <div class="container">
    Processing Login:
    <sdx-loading-spinner id="spinner-login" size="large" sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <div id="login">Login {{ this.$route.params.provider }}!</div>
  </div>
</template>

<script>
import loginService, {EVENT_LOGIN_CHANGED} from '@/modules/login/service';
import userService from "@/services/user.service";
import loadingSpinnerService from "@/services/loading-spinner.service";
import {logger} from "@/services/logger.service";

export default {
  async mounted() {
    loadingSpinnerService.show("login");

    //New Login -> clear all session data (probably from another user)
    logger.debug("Clear user data")
    await userService.clearUserData();
    logger.debug("Provider Login")
    await loginService.providerLogin(
        this.$route.params.provider,
        this.$route.query.code,
        this.$route.query.state);
    logger.debug("Update user information")
    await userService.updateUserInformation();
    logger.debug("EVENT: " + EVENT_LOGIN_CHANGED);
    this.$emit(EVENT_LOGIN_CHANGED, {});
    loadingSpinnerService.hide("login");
    let returnUrl=localStorage.getItem("returnUrl") || "/";
    logger.debug("Return: "+ returnUrl)
    localStorage.removeItem("returnUrl");
    this.$router.push(returnUrl);
  }
};
</script>